<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-22 08:40:14
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="租售类型" prop="type">
                <el-radio-group v-model="viewData.type">
                    <el-radio :label="1">出租</el-radio>
                    <el-radio :label="2">出售</el-radio>
                    <el-radio :label="3">求租</el-radio>
                    <el-radio :label="4">求购</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="小区" prop="commId">
                <el-select
                        v-model="viewData.commId"
                        @change="cmmChange"
                        clearable
                        filterable
                        placeholder="请选择小区"
                >
                <el-option v-for="item in optionList"
                            :key="item.id"
                            :label="item.commName"
                            :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="资源类型" prop="zushou_type">
                <el-radio-group v-model="viewData.zushou_type">
                    <el-radio :label="1">住宅</el-radio>
                    <el-radio :label="2">车位</el-radio>
                    <el-radio :label="3">车库</el-radio>
                    <el-radio :label="4">储间</el-radio>
                    <el-radio :label="5">商业</el-radio>
                    <el-radio :label="6">写字楼</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="房屋" prop="resource_id">
                <el-select
                        v-model="viewData.resource_id"
                        clearable
                        filterable
                        placeholder="请选择房屋"
                >
                <el-option v-for="item in resourceList"
                            :key="item.id"
                            :label="item.resourceCode"
                            :value="item.id" />
                </el-select>
            </el-form-item>
            <div v-if="viewData.zushou_type==1">
                <el-form-item label="室" prop="shi">
                    <el-input v-model="viewData.shi" />
                </el-form-item>
                <el-form-item label="厅" prop="ting">
                    <el-input v-model="viewData.ting" />
                </el-form-item>
                <el-form-item label="卫" prop="wei">
                    <el-input v-model="viewData.wei" />
                </el-form-item>
                <el-form-item label="楼层" prop="floor">
                    <el-input v-model="viewData.floor" />
                </el-form-item>
                <el-form-item label="面积" prop="area">
                    <el-input v-model="viewData.area" />
                </el-form-item>
            </div>
            <div v-else-if="viewData.zushou_type==5">
                <el-form-item label="位置" prop="address">
                    <el-input v-model="viewData.address" />
                </el-form-item>
                <el-form-item label="面积" prop="area">
                    <el-input v-model="viewData.area" />
                </el-form-item>
                <el-form-item label="房号" prop="zushou_name">
                    <el-input v-model="viewData.zushou_name" />
                </el-form-item>
            </div>
            <div v-else-if="viewData.zushou_type==6">
                <el-form-item label="楼层" prop="floor">
                    <el-input v-model="viewData.floor" />
                </el-form-item>
                <el-form-item label="面积" prop="area">
                    <el-input v-model="viewData.area" />
                </el-form-item>
                <el-form-item label="房号" prop="zushou_name">
                    <el-input v-model="viewData.zushou_name" />
                </el-form-item>
            </div>
            <div v-else>
                <el-form-item label="车位号" prop="zushou_name" v-if="viewData.zushou_type==2">
                    <el-input v-model="viewData.zushou_name" />
                </el-form-item>
                <el-form-item label="车库号" prop="zushou_name" v-else-if="viewData.zushou_type==3">
                    <el-input v-model="viewData.zushou_name" />
                </el-form-item>
                <el-form-item label="储间号" prop="zushou_name" v-else-if="viewData.zushou_type==4">
                    <el-input v-model="viewData.zushou_name" />
                </el-form-item>
            </div>
            <el-form-item label="价格" prop="price" v-if="viewData.type==1">
                <el-input v-model="viewData.price" />
                <span v-if="viewData.zushou_type==5">元/年</span>
                <span v-else-if="viewData.zushou_type==6">元/平米每天</span>
                <span v-else>元/月</span>
            </el-form-item>
            <el-form-item label="联系人" prop="person">
                <el-input v-model="viewData.person" />
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
                <el-input v-model="viewData.phone" />
            </el-form-item>
            <el-form-item label="封面图">
                <image-upload ref="imageUpload1"
                          v-if="showUpload"
                          :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸750*370,请自己处理好宽高比例`"
                          :image-list="imageDefaultList1"
                          @updateImg="onUpdateImg1($event)"></image-upload>
            </el-form-item>
            <el-form-item label="图片数组">
                <image-upload ref="imageUpload"
                          v-if="showUpload"
                          :maxNumber="9"
                          :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸750*370,请自己处理好宽高比例`"
                          :image-list="imageDefaultList"
                          @updateImg="onUpdateImg($event)"></image-upload>
            </el-form-item>
            <el-form-item label="详情" prop="content">
                <vue-ueditor-wrap v-if="showUpload" ref="ueditor" v-model="viewData.content" :config="ueconfig"></vue-ueditor-wrap>
            </el-form-item>
            <!-- <el-form-item label="发布时间">
            <el-date-picker v-model="viewData.publish_at"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="发布时间">
            </el-date-picker>
          </el-form-item> -->

          <!-- <el-form-item label="来源">
                <el-input v-model="viewData.source" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number
                    size="mini"
                    style="width: 100px"
                    v-model="viewData.sort"
                    controls-position="right"
                    :min="0"
                ></el-input-number>
            </el-form-item> -->
            <el-form-item label="是否置顶">
                <el-switch
                    v-model="viewData.is_top"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
            <el-form-item label="是否banner" v-show="false">
                <el-switch
                    v-model="viewData.is_banner"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div>
    </div>
</template>

<script>
import ImageUpload from "@/components/Upload/image";
import fetch from "@/api/tianzheng/sell";
import Qu from "@/api/tianzheng/Qu";
import VueUeditorWrap from 'vue-ueditor-wrap'
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            thumbList: [],
            imageDefaultList: "",
            thumbList1: [],
            imageDefaultList1: "",
            showUpload:false,
            optionList: [],
            resourceList: [],
            ueconfig: {
                initialFrameHeight: 300,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 关键配置：提高弹窗层级
                zIndex: 9000,  // el-dialog默认z-index是2000+，设置更高的值
                catchRemoteImageEnable: true, // 抓取远程图片
                serverUrl: 'https://xcx.tzwyfw.com/ueditor/controller.php',
                withCredentials: true,
            },
            viewData: {
                id:'',
                type: 1,
                zushou_type: 1,
                zushou_name: '',
                commId: "",
                resource_id: "",
                shi: "",
                ting: "",
                wei: "",
                floor: "",
                address: "",
                area: "",
                price: "",
                person: "",
                phone: "",
                thumb: "",
                pic_arr: "",
                content: "",
                is_top: "",
                is_banner: 1,
                sort: 0,
                status: 1,
            },
            rules: {
                type: [
                    {
                        required: true,
                        message: "请选择类型",
                        trigger: "blur",
                    },
                ],
                commId: [
                    {
                        required: true,
                        message: "请选择小区",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                person: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        Pagination,
        VueUeditorWrap,
        ImageUpload
    },
    created() {
        this.getSelectCity()
    },
    watch:{
    },
    methods: {
        // 小区切换 调用房屋资源列表
        cmmChange(val){
            if (val) {
                this.resourceList = []
                this.viewData.resource_id =''
                this.getResourceList(val)
            }
        },
        // 调用房屋资源 接口
        getResourceList (val) {
            let ps ={
                commId:val,
                page:1,
                size:10000
            }
            let that = this;
            Qu.resourceList(ps).then((res) => {
                that.resourceList = res.result.list;
            });
        },
        // 更新图片
        onUpdateImg1 (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList1 = thumbList;
        },
        // 更新图片
        onUpdateImg (val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            let that = this
            this.viewData = {
                id:'',
                type: "",
                zushou_type: 1,
                zushou_name: "",
                commId: "",
                resource_id: "",
                shi: "",
                ting: "",
                wei: "",
                floor: "",
                address: "",
                area: "",
                price: "",
                person: "",
                phone: "",
                thumb: "",
                pic_arr: "",
                content: "",
                is_top: 0,
                is_banner: 1,
                sort: 0,
                status: 1,
            }
            this.resetForm()
            this.showUpload = true
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        that.getResourceList(that.viewData.commId)
                        if (that.viewData.thumb) {
                            let arr = []
                            let obj = {
                                    name: that.viewData.thumb,
                                    path: that.viewData.thumb,
                                    url: that.$publicData.imgUrl + that.viewData.thumb,
                                }
                                arr.push(obj);
                                that.imageDefaultList1 =  JSON.stringify(arr);
                        }
                        if (that.viewData.pic_arr.length > 0) {
                            let imgList = [];
                            let thumb_arr = that.viewData.pic_arr;
                            thumb_arr.forEach((ele, index) => {
                                let obj = {
                                    name: ele,
                                    path: ele,
                                    url: that.$publicData.imgUrl + ele,
                                }
                                imgList.push(obj);
                            })
                            // 回显图
                            that.imageDefaultList = JSON.stringify(imgList);
                        };
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
            let that = this
            console.log(this.viewData)
            if (this.thumbList1.length>0){
                this.viewData.thumb = this.thumbList1[0];
            } else {
                if (this.viewData.type == 1 || this.viewData.type == 2 ) {
                    this.$message.warning("请上传封面图")
                    return
                }
            }
            if (this.thumbList.length>0){
                this.viewData.pic_arr = this.thumbList;
            } else {
                if (this.viewData.type == 1 || this.viewData.type == 2 ) {
                    this.$message.warning("请上传图片数组")
                    return
                }
            }
            if (this.viewData.zushou_type==1) {
                if (this.viewData.shi == null || this.viewData.shi == undefined || this.viewData.shi == "") {
                    this.$message.warning("请输入室")
                    return
                }
                if (this.viewData.ting == null || this.viewData.ting == undefined || this.viewData.ting == "") {
                    this.$message.warning("请输入厅")
                    return
                }
                if (this.viewData.wei == null || this.viewData.wei == undefined || this.viewData.wei == "") {
                    this.$message.warning("请输入卫")
                    return
                }
                if (this.viewData.floor == null || this.viewData.floor == undefined || this.viewData.floor == "") {
                    this.$message.warning("请输入楼层")
                    return
                }
                if (this.viewData.area == null || this.viewData.area == undefined || this.viewData.area == "") {
                    this.$message.warning("请输入面积")
                    return
                }
            } else if (this.viewData.zushou_type==5) {
                if (this.viewData.address == null || this.viewData.address == undefined || this.viewData.address == "") {
                    this.$message.warning("请输入位置")
                    return
                }
                if (this.viewData.zushou_name == null || this.viewData.zushou_name == undefined || this.viewData.zushou_name == "") {
                    this.$message.warning("请输入房号")
                    return
                }
                if (this.viewData.area == null || this.viewData.area == undefined || this.viewData.area == "") {
                    this.$message.warning("请输入面积")
                    return
                }
                this.viewData.shi = '1'
                this.viewData.ting = '1'
                this.viewData.wei = '1'
                this.viewData.floor = '1'
            } else if (this.viewData.zushou_type==6) {
                if (this.viewData.zushou_name == null || this.viewData.zushou_name == undefined || this.viewData.zushou_name == "") {
                    this.$message.warning("请输入房号")
                    return
                }
                if (this.viewData.floor == null || this.viewData.floor == undefined || this.viewData.floor == "") {
                    this.$message.warning("请输入楼层")
                    return
                }
                if (this.viewData.area == null || this.viewData.area == undefined || this.viewData.area == "") {
                    this.$message.warning("请输入面积")
                    return
                }
                this.viewData.shi = '1'
                this.viewData.ting = '1'
                this.viewData.wei = '1'
            } else {
                
                if (this.viewData.zushou_name == null || this.viewData.zushou_name == undefined || this.viewData.zushou_name == "") {
                        let name = '号'
                    if (this.viewData.zushou_type==2) {
                        name = '车位号'
                    } else if (this.viewData.zushou_type==3) {
                        name = '车库号'
                    } else if (this.viewData.zushou_type==4) {
                        name = '储间号'
                    }
                    this.$message.warning("请输入"+name)
                    return
                }
                this.viewData.shi = '1'
                this.viewData.ting = '1'
                this.viewData.wei = '1'
                this.viewData.floor = '1'
                this.viewData.area = '1'
            }
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(this.viewData.id){
						// 编辑
						fetch.edit(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.thumbList = [];
            this.imageDefaultList = "";
            if (this.$refs.imageUpload) {
                this.$refs.imageUpload.clearFileList();
            }
            this.thumbList1 = [];
            this.imageDefaultList1 = "";
            if (this.$refs.imageUpload1) {
                this.$refs.imageUpload1.clearFileList();
            }
            this.showUpload = false;
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
